module.exports = __webpack_public_path__ + "static/img/class_task_stu_manage.c35f126.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/class_task_stu_manage.png
// module id = e6vR
// module chunks = 2